import { URL } from '../../../variables';

export async function essayAiRequest(token, redacaoId, suffix = '', method = 'GET', data) {
  const form = data instanceof FormData;
  const response = await fetch(`${URL}api/faculdade/redacoes/${redacaoId}/ia${suffix}`, {
    method,
    headers: { Accept: 'application/json', Authorization: `Bearer ${token}`, ...(data && !form ? { 'Content-Type': 'application/json' } : {}) },
    body: data ? (form ? data : JSON.stringify(data)) : undefined,
  });
  const result = await response.json().catch(() => null);
  if (!response.ok || !result) {
    const error = new Error(result?.errors ? Object.values(result.errors).flat().join(' ') : result?.message || 'Não foi possível concluir a operação.');
    error.status = response.status;
    throw error;
  }
  return result;
}
